import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

export const getList = (data) => {
  return axios.request({
    url: "/warehouse/shipments/getHeadWayAwb",
    method: "post",
    data,
  });
};

// 关联中港单
export const setBindPackage = (data) => {
  return axios.request({
    url: "/warehouse/shipments/setBindPackage",
    method: "post",
    data,
  });
};

export const getWarehouseByShipmentNumber = shipmentNumber => {
  return axios.request({
    url: `/warehouse/shipments/getWarehouseByShipmentNumber?shipmentNumber=${shipmentNumber}`,
    method: "get",
  })
}

export const addStorageFees = params => {
  return axios.request({
    url: "/warehouse/incidentals/addStorageFees",
    method: "post",
    data: params,
  })
}

export const loadExtraFees = params => {
  return axios.request({
    url: "/warehouse/incidentals/loadExtraFees",
    method: "post",
    data: params,
  })
}

// 杂费搜索栏下拉选项（送仓仓库 / 服务仓库 / 销售账号）
// 返回结构预期：{ targetWarehouse: [{ value, label }], serviceWarehouse: [...], salesman: [...] }
export const getExtraFeesOptions = params => {
  return axios.request({
    url: "/warehouse/incidentals/getOptions",
    method: "get",
    params,
  })
}

// 杂费搜索栏下的用户自动填充的返回值
// 返回结构预期：[{ value, label }]
export const searchCustomerOptions = params => {
  return axios.request({
    url: "/warehouse/incidentals/searchCustomerOptions",
    method: "get",
    params,
  })
}

// 创建手动创建仓租费用
export const createManualStorageFees = params => {
  return axios.request({
    url: "/warehouse/incidentals/createManualStorageFees",
    method: "post",
    data: params,
  })
}

// 读取当前订单号可以服务的仓库信息
// 返回结构预期：[{ value, label }]
export const getServiceWarehouse = params => {
  return axios.request({
    url: "/warehouse/incidentals/getServiceWarehouse",
    method: "get",
    params,
  })
}

// 未报价 / 已报价 页面搜索栏的「费用」下拉选项
// 返回结构预期：payload 直接为 [{ value, label }]
export const getFeeOptions = params => {
  return axios.request({
    url: "/warehouse/incidentals/getFeeOptions",
    method: "get",
    params,
  })
}

// 删除仓租费用
export const deleteStorageFees = (params) => {
  return axios.request({
    url: "/warehouse/incidentals/deleteStorageFees",
    method: "delete",
    data: params,
  })
}

// 读取杂费记录
export const getFeeLogger = params => {
  return axios.request({
    url: "/warehouse/incidentals/getFeeLogger",
    method: "get",
    params,
  })
}

// 读取杂费详情
export const getFeeCharge = params => {
  return axios.request({
    url: "/warehouse/incidentals/getFeeCharge",
    method: "get",
    params,
  })
}
